// extracted by mini-css-extract-plugin
module.exports = {"Modal":"changeBuyerModal_Modal__3_tH3","RootModal":"changeBuyerModal_RootModal__314hz","Form":"changeBuyerModal_Form__3ODfz","Button":"changeBuyerModal_Button__2yxDV"};